<template>
    <v-container class="ma-0 pa-0">
            <title hieght="60" class="text-no-wrap ma-0 pa-0">
                    {{pokemonType.name}}
            </title>
            <v-img
                class="self-center"
                :src="getIcon()"
                contain
            >
            </v-img>
    </v-container>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {pokemonImageSrc} from '@/utils/pokemonImage';

export default {
    components: {},
    props: {
        pokemonType: {type: Object, default: undefined},
    },
    computed: {
        ...mapGetters({
            isLoading: 'journey/isLoading',
        }),
    },
    methods: {
        ...mapActions({
            fetchObject: 'pokemon/fetchObject',
        }),
        getIcon(){
            return pokemonImageSrc(this.pokemonType.img);
        }},
}
</script>

